import { Input, InputMasks } from '@ui-components/neo.tax';

import { ValueInputType } from './types';

export const NumberValueInput: ValueInputType = ({ onChange, value }): React.ReactElement => (
  <Input
    mask={InputMasks.NUMBER}
    value={value ?? ''}
    onChange={(value): void => {
      onChange(value);
    }}
  />
);
